const inicialState = {
  role: {},
  usuario: '',
  usuarioId: 0,
  medicoId: 0,
  medico: '',
  isResidente: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/usuario/usuario.state.js